import React from 'react';
import { Link, navigate } from 'gatsby';
import { deleteMe } from '../../actions/livquest/deleteMe';
import { sendEvent } from '../../actions/analytics';
import { useLiv } from '../../context/liv';
import { OutboundLink } from 'gatsby-plugin-google-gtag';

const LivquestCalviNav = () => {
  const { askId, setAskId } = useLiv();

  const onNew = () => {
    deleteMe().then(() => {
      setAskId(null);
      sendEvent('reset', {
        ask_id: askId,
      });
      navigate('/new');
    });
  };

  const onBlocked = () => {
    deleteMe(true).then(() => {
      sendEvent('blocked', {
        ask_id: askId,
      });
      navigate('/new');
    });
  };

  return (
    <nav>
      <ul>
        <li className="my-2">
          <a href="#new" onClick={onNew}>
            Commencer une nouvelle aventure
          </a>
        </li>
        <li className="my-8">
          <a href="#blocked" onClick={onBlocked}>
            Je suis bloqué
          </a>
        </li>
        <li className="my-8">
          <OutboundLink
            href="https://artists.landr.com/lesremparts"
            target="_blank"
            rel="noopener noreferrer"
          >
            Écouter l&apos;album
          </OutboundLink>
        </li>
        <li className="my-8">
          <Link to="/review">Donner mon avis</Link>
        </li>
      </ul>
    </nav>
  );
};

export { LivquestCalviNav };
